import { getChatRouteFromMessagingType } from 'features/Messaging/messaging-helpers'
import _ from 'lodash'
import dashboardApi from 'services/api/dashboard'
import messagingApi from 'services/api/messaging'
import subscribersApi from 'services/api/subscribers'

import { history } from '../main/store'
import {
  BUMP_PENDING_BOOKING_COUNT,
  BUMP_PENDING_DIRECT_THREAD_COUNT,
  BUMP_PENDING_GDS_CHAT_COUNT,
  BUMP_PENDING_REVIEW_THREAD_COUNT,
  BUMP_PENDING_SALES_THREAD_COUNT,
  BUMP_PENDING_SERVICE_THREAD_COUNT,
  CHANGE_CHAT_OWNERSHIP_FAILED,
  CHANGE_CHAT_OWNERSHIP_STARTED,
  CHANGE_CHAT_OWNERSHIP_SUCCESS,
  CHANGE_THREAD_OWNER,
  GET_DIRECT_CHATS_FAILED,
  GET_DIRECT_CHATS_STARTED,
  GET_DIRECT_CHATS_SUCCESS,
  GET_DIRECT_MESSAGE_FROM_PUSH,
  GET_DIRECT_THREAD_FAILED,
  GET_DIRECT_THREAD_STARTED,
  GET_DIRECT_THREAD_SUCCESS,
  GET_INTENT_TYPES_SUCCESS,
  GET_RESOLVED_SALES_CHATS_FAILED,
  GET_RESOLVED_SALES_CHATS_STARTED,
  GET_RESOLVED_SALES_CHATS_SUCCESS,
  GET_REVIEW_CHATS_FAILED,
  GET_REVIEW_CHATS_STARTED,
  GET_REVIEW_CHATS_SUCCESS,
  GET_REVIEW_MESSAGE_FROM_PUSH,
  GET_REVIEW_THREAD_FAILED,
  GET_REVIEW_THREAD_STARTED,
  GET_REVIEW_THREAD_SUCCESS,
  GET_SALES_CHATS_FAILED,
  GET_SALES_CHATS_STARTED,
  GET_SALES_CHATS_SUCCESS,
  GET_SALES_MESSAGE_FROM_PUSH,
  GET_SALES_THREAD_FAILED,
  GET_SALES_THREAD_STARTED,
  GET_SALES_THREAD_SUCCESS,
  GET_SERVICE_CHATS_FAILED,
  GET_SERVICE_CHATS_STARTED,
  GET_SERVICE_CHATS_SUCCESS,
  GET_SERVICE_MESSAGE_FROM_PUSH,
  GET_SERVICE_THREAD_FAILED,
  GET_SERVICE_THREAD_STARTED,
  GET_SERVICE_THREAD_SUCCESS,
  OPTING_IN_GUEST_TO_CHAT_FAILED,
  OPTING_IN_GUEST_TO_CHAT_STARTED,
  OPTING_IN_GUEST_TO_CHAT_SUCCESS,
  OPTING_OUT_GUEST_FROM_CHAT_FAILED,
  OPTING_OUT_GUEST_FROM_CHAT_STARTED,
  OPTING_OUT_GUEST_FROM_CHAT_SUCCESS,
  POST_TYPING_FAILED,
  POST_TYPING_STARTED,
  POST_TYPING_SUCCESS,
  RESOLVE_THREAD_DIRECT_STARTED,
  RESOLVE_THREAD_DIRECT_SUCCESS,
  RESOLVE_THREAD_FAILED,
  RESOLVE_THREAD_REVIEW_STARTED,
  RESOLVE_THREAD_REVIEW_SUCCESS,
  RESOLVE_THREAD_SALES_STARTED,
  RESOLVE_THREAD_SALES_SUCCESS,
  RESOLVE_THREAD_SERVICE_STARTED,
  RESOLVE_THREAD_SERVICE_SUCCESS,
  SEND_DIRECT_MESSAGE_FAILED,
  SEND_DIRECT_MESSAGE_STARTED,
  SEND_DIRECT_MESSAGE_SUCCESS,
  SEND_REVIEW_MESSAGE_FAILED,
  SEND_REVIEW_MESSAGE_STARTED,
  SEND_REVIEW_MESSAGE_SUCCESS,
  SEND_SALES_MESSAGE_FAILED,
  SEND_SALES_MESSAGE_STARTED,
  SEND_SALES_MESSAGE_SUCCESS,
  SEND_SERVICE_MESSAGE_FAILED,
  SEND_SERVICE_MESSAGE_STARTED,
  SEND_SERVICE_MESSAGE_SUCCESS,
  UPDATE_DIRECT_CHATS_STARTED,
  UPDATE_DIRECT_TYPING_USERS,
  UPDATE_PENDING_THREAD_COUNT,
  UPDATE_REVIEW_CHATS_STARTED,
  UPDATE_REVIEW_TYPING_USERS,
  UPDATE_SALES_CHATS_STARTED,
  UPDATE_SALES_TYPING_USERS,
  UPDATE_SERVICE_CHATS_STARTED,
  UPDATE_SERVICE_TYPING_USERS,
  UPDATE_SINGLE_DIRECT_TYPING_USER,
  UPDATE_SINGLE_REVIEW_TYPING_USER,
  UPDATE_SINGLE_SALES_TYPING_USER,
  UPDATE_SINGLE_SERVICE_TYPING_USER
} from './actionTypes'

function getChatActionType(kind) {
  switch (kind) {
    case 'service':
      return {
        GET_STARTED: GET_SERVICE_CHATS_STARTED,
        GET_SUCCESS: GET_SERVICE_CHATS_SUCCESS,
        GET_FAILED: GET_SERVICE_CHATS_FAILED,
        UPDATE_STARTED: UPDATE_SERVICE_CHATS_STARTED,
        RESOLVE_STARTED: RESOLVE_THREAD_SERVICE_STARTED,
        RESOLVE_SUCCESS: RESOLVE_THREAD_SERVICE_SUCCESS,
        UPDATE_TYPING_USERS: UPDATE_SERVICE_TYPING_USERS,
        UPDATE_SINGLE_TYPING_USER: UPDATE_SINGLE_SERVICE_TYPING_USER,
        GET_MESSAGE_FROM_PUSH: GET_SERVICE_MESSAGE_FROM_PUSH,
        SEND_MESSAGE_STARTED: SEND_SERVICE_MESSAGE_STARTED,
        SEND_MESSAGE_FAILED: SEND_SERVICE_MESSAGE_FAILED,
        SEND_MESSAGE_SUCCESS: SEND_SERVICE_MESSAGE_SUCCESS,
        GET_THREAD_STARTED: GET_SERVICE_THREAD_STARTED,
        GET_THREAD_FAILED: GET_SERVICE_THREAD_FAILED,
        GET_THREAD_SUCCESS: GET_SERVICE_THREAD_SUCCESS,
        BUMP_PENDING_THREAD_COUNT: BUMP_PENDING_SERVICE_THREAD_COUNT
      }

    case 'sales':
      return {
        GET_STARTED: GET_SALES_CHATS_STARTED,
        GET_SUCCESS: GET_SALES_CHATS_SUCCESS,
        GET_FAILED: GET_SALES_CHATS_FAILED,
        UPDATE_STARTED: UPDATE_SALES_CHATS_STARTED,
        RESOLVE_STARTED: RESOLVE_THREAD_SALES_STARTED,
        RESOLVE_SUCCESS: RESOLVE_THREAD_SALES_SUCCESS,
        UPDATE_TYPING_USERS: UPDATE_SALES_TYPING_USERS,
        UPDATE_SINGLE_TYPING_USER: UPDATE_SINGLE_SALES_TYPING_USER,
        GET_MESSAGE_FROM_PUSH: GET_SALES_MESSAGE_FROM_PUSH,
        SEND_MESSAGE_STARTED: SEND_SALES_MESSAGE_STARTED,
        SEND_MESSAGE_FAILED: SEND_SALES_MESSAGE_FAILED,
        SEND_MESSAGE_SUCCESS: SEND_SALES_MESSAGE_SUCCESS,
        GET_THREAD_STARTED: GET_SALES_THREAD_STARTED,
        GET_THREAD_FAILED: GET_SALES_THREAD_FAILED,
        GET_THREAD_SUCCESS: GET_SALES_THREAD_SUCCESS,
        BUMP_PENDING_THREAD_COUNT: BUMP_PENDING_SALES_THREAD_COUNT
      }

    case 'review':
      return {
        GET_STARTED: GET_REVIEW_CHATS_STARTED,
        GET_SUCCESS: GET_REVIEW_CHATS_SUCCESS,
        GET_FAILED: GET_REVIEW_CHATS_FAILED,
        UPDATE_STARTED: UPDATE_REVIEW_CHATS_STARTED,
        RESOLVE_STARTED: RESOLVE_THREAD_REVIEW_STARTED,
        RESOLVE_SUCCESS: RESOLVE_THREAD_REVIEW_SUCCESS,
        UPDATE_TYPING_USERS: UPDATE_REVIEW_TYPING_USERS,
        UPDATE_SINGLE_TYPING_USER: UPDATE_SINGLE_REVIEW_TYPING_USER,
        GET_MESSAGE_FROM_PUSH: GET_REVIEW_MESSAGE_FROM_PUSH,
        SEND_MESSAGE_STARTED: SEND_REVIEW_MESSAGE_STARTED,
        SEND_MESSAGE_FAILED: SEND_REVIEW_MESSAGE_FAILED,
        SEND_MESSAGE_SUCCESS: SEND_REVIEW_MESSAGE_SUCCESS,
        GET_THREAD_STARTED: GET_REVIEW_THREAD_STARTED,
        GET_THREAD_FAILED: GET_REVIEW_THREAD_FAILED,
        GET_THREAD_SUCCESS: GET_REVIEW_THREAD_SUCCESS,
        BUMP_PENDING_THREAD_COUNT: BUMP_PENDING_REVIEW_THREAD_COUNT
      }

    case 'direct':
      return {
        GET_STARTED: GET_DIRECT_CHATS_STARTED,
        GET_SUCCESS: GET_DIRECT_CHATS_SUCCESS,
        GET_FAILED: GET_DIRECT_CHATS_FAILED,
        UPDATE_STARTED: UPDATE_DIRECT_CHATS_STARTED,
        RESOLVE_STARTED: RESOLVE_THREAD_DIRECT_STARTED,
        RESOLVE_SUCCESS: RESOLVE_THREAD_DIRECT_SUCCESS,
        UPDATE_TYPING_USERS: UPDATE_DIRECT_TYPING_USERS,
        UPDATE_SINGLE_TYPING_USER: UPDATE_SINGLE_DIRECT_TYPING_USER,
        GET_MESSAGE_FROM_PUSH: GET_DIRECT_MESSAGE_FROM_PUSH,
        SEND_MESSAGE_STARTED: SEND_DIRECT_MESSAGE_STARTED,
        SEND_MESSAGE_FAILED: SEND_DIRECT_MESSAGE_FAILED,
        SEND_MESSAGE_SUCCESS: SEND_DIRECT_MESSAGE_SUCCESS,
        GET_THREAD_STARTED: GET_DIRECT_THREAD_STARTED,
        GET_THREAD_FAILED: GET_DIRECT_THREAD_FAILED,
        GET_THREAD_SUCCESS: GET_DIRECT_THREAD_SUCCESS,
        BUMP_PENDING_THREAD_COUNT: BUMP_PENDING_DIRECT_THREAD_COUNT
      }

    default:
      break
  }
}

export const postTyping = ({ chatId, isTyping }) => {
  return async dispatch => {
    dispatch({
      type: POST_TYPING_STARTED
    })

    try {
      await dashboardApi.postTyping({ chatId, isTyping })
      dispatch({
        type: POST_TYPING_SUCCESS
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: POST_TYPING_FAILED
      })
    }
  }
}

export const getChats = kind => {
  const actions = getChatActionType(kind)

  return async dispatch => {
    dispatch({
      type: actions.GET_STARTED
    })

    try {
      const response = await dashboardApi.getChats(kind)
      dispatch({
        type: actions.GET_SUCCESS,
        payload: response
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: actions.GET_FAILED,
        payload: err
      })
    }
  }
}

export const updatePendingThreadCount = () => {
  return async dispatch => {
    messagingApi
      .getPendingChatCount()
      .then(res => {
        const {
          pendingMessageCountForDuring,
          pendingMessageCountForAfter,
          pendingMessageCountForBefore,
          pendingMessageCountForDirect,
          pendingMessageCountForGds,
          pendingBookingCount
        } = res

        dispatch({
          type: UPDATE_PENDING_THREAD_COUNT,
          payload: {
            pendingMessageCountForDuring,
            pendingMessageCountForAfter,
            pendingMessageCountForBefore,
            pendingMessageCountForDirect,
            pendingMessageCountForGds,
            pendingBookingCount
          }
        })
      })
      .catch(() => {
        dispatch({
          type: UPDATE_PENDING_THREAD_COUNT,
          payload: {
            pendingMessageCountForDuring: 0,
            pendingMessageCountForAfter: 0,
            pendingMessageCountForBefore: 0,
            pendingMessageCountForDirect: 0,
            pendingMessageCountForGds: 0,
            pendingBookingCount: 0
          }
        })
      })
  }
}

export const bumpPendingThreadCount = (increment, hub) => {
  const actions = getChatActionType(hub)

  return async dispatch => {
    dispatch({
      type: actions.BUMP_PENDING_THREAD_COUNT,
      payload: Number(increment)
    })
  }
}

export const bumpPendingBookingCount = increment => {
  return async dispatch => {
    dispatch({
      type: BUMP_PENDING_BOOKING_COUNT,
      payload: Number(increment)
    })
  }
}

export const bumpPendingGdsChatCount = increment => {
  return async dispatch => {
    dispatch({
      type: BUMP_PENDING_GDS_CHAT_COUNT,
      payload: Number(increment)
    })
  }
}

export const updateChats = kind => {
  const actions = getChatActionType(kind)

  return async dispatch => {
    dispatch({
      type: actions.UPDATE_STARTED
    })

    try {
      const response = await dashboardApi.getChats(kind)
      dispatch({
        type: actions.GET_SUCCESS,
        payload: response
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: actions.GET_FAILED,
        payload: err
      })
    }
  }
}

export const getThread = (chatId, messagingType) => {
  const actions = getChatActionType(messagingType)
  const route = getChatRouteFromMessagingType(messagingType)

  return async dispatch => {
    dispatch({
      type: actions.GET_THREAD_STARTED,
      payload: { chatId }
    })

    try {
      const response = await dashboardApi.getThread(chatId, messagingType)
      dispatch({
        type: actions.GET_THREAD_SUCCESS,
        payload: response
      })
      dispatch({
        type: actions.UPDATE_TYPING_USERS,
        payload: {}
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: actions.GET_THREAD_FAILED,
        payload: err
      })
      history.push(route)
    }
  }
}

export const changeChatOwnership = (chatId, messagingType) => {
  return async dispatch => {
    dispatch({
      type: CHANGE_CHAT_OWNERSHIP_STARTED,
      payload: chatId
    })

    try {
      await dashboardApi.postTakeOwnership(chatId)
      dispatch(getThread(chatId, messagingType))
      dispatch({
        type: CHANGE_CHAT_OWNERSHIP_SUCCESS,
        payload: chatId
      })
    } catch (error) {
      dispatch({
        type: CHANGE_CHAT_OWNERSHIP_FAILED,
        payload: error
      })
    }
  }
}

export const sendMessage = ({
  message,
  subject,
  chatId,
  senderName,
  messagingType,
  mediaUrls,
  messageKind = 'Sms',
  email
}) => {
  const actions = getChatActionType(messagingType)

  return async dispatch => {
    const controlKey = _.uniqueId(chatId)

    dispatch({
      type: actions.SEND_MESSAGE_STARTED,
      payload: {
        chatId,
        message: {
          content: subject,
          senderName,
          chatMessageKind: messageKind,
          emailDetails: {},
          scheduledOn: new Date().toJSON(),
          isSenderClient: false,
          controlKey,
          shouldApplyOffset: true,
          deliveryStatus: 'Sending'
        }
      }
    })
    try {
      const response = await dashboardApi.sendMessage({
        message,
        messageKind,
        subject,
        chatId,
        controlKey,
        mediaUrls,
        email
      })
      dispatch({
        type: actions.SEND_MESSAGE_SUCCESS,
        payload: {
          chatId,
          message: { ...response, senderName }
        }
      })
    } catch (err) {
      console.warn(err)
      dispatch({
        type: actions.SEND_MESSAGE_FAILED,
        payload: err
      })
    }
  }
}

export const getMessageFromPush = (subscriberId, message, status) => {
  return async dispatch => {
    dispatch({
      type: getChatActionType('sales').GET_MESSAGE_FROM_PUSH,
      payload: { subscriberId, message, status }
    })

    dispatch({
      type: getChatActionType('service').GET_MESSAGE_FROM_PUSH,
      payload: { subscriberId, message, status }
    })

    dispatch({
      type: getChatActionType('review').GET_MESSAGE_FROM_PUSH,
      payload: { subscriberId, message, status }
    })

    dispatch({
      type: getChatActionType('direct').GET_MESSAGE_FROM_PUSH,
      payload: { subscriberId, message, status }
    })
  }

  // const actions = getChatActionType(kind)

  // return async dispatch => {
  //   dispatch({
  //     type: actions.GET_MESSAGE_FROM_PUSH,
  //     payload: { chatId, message }
  //   })
  // }
}

export const resolveThread = (chatId, messagingType) => {
  const actions = getChatActionType(messagingType)

  const route = getChatRouteFromMessagingType(messagingType)

  return async dispatch => {
    dispatch({
      type: actions.RESOLVE_STARTED,
      payload: { chatId }
    })

    try {
      await dashboardApi.resolveThread(chatId)
      dispatch({
        type: actions.RESOLVE_SUCCESS,
        payload: { chatId }
      })
      history.push(route)
      await dispatch(updateChats(messagingType))
    } catch (err) {
      console.warn(err)
      dispatch({
        type: RESOLVE_THREAD_FAILED,
        payload: { chatId }
      })
    }
  }
}

export const updateTypingUsers = (users, messagingType) => {
  const actions = getChatActionType(messagingType)

  return {
    type: actions.UPDATE_TYPING_USERS,
    payload: users.reduce((prev, current) => {
      return {
        ...prev,
        [current.userId]: {
          firstName: current.firstName,
          userId: current.userId,
          startedOn: current.startedOn
        }
      }
    }, {})
  }
}

export const updateSingleTypingUser = (firstName, userId, isTyping, kind) => {
  const actions = getChatActionType(kind)

  return {
    type: actions.UPDATE_SINGLE_TYPING_USER,
    payload: {
      firstName,
      userId,
      startedOn: Date.now(),
      isTyping
    }
  }
}

export const updateThreadOwnership = (chatId, currentOwner) => {
  return {
    type: CHANGE_THREAD_OWNER,
    payload: { chatId, currentOwner }
  }
}

export const optGuestOutFromChat = ({ chatId, sendUpdateText, customMessage }) => {
  return async dispatch => {
    dispatch({
      type: OPTING_OUT_GUEST_FROM_CHAT_STARTED,
      payload: { chatId }
    })

    subscribersApi.updateStatus
      .doNotCall({ chatId, sendUpdateText, customMessage })
      .then(() => {
        dispatch({
          type: OPTING_OUT_GUEST_FROM_CHAT_SUCCESS,
          payload: { chatId }
        })
      })
      .catch(err => {
        console.warn({ err })
        dispatch({
          type: OPTING_OUT_GUEST_FROM_CHAT_FAILED,
          payload: err
        })
      })
  }
}

export const optInGuestToChat = ({ chatId }) => {
  return async dispatch => {
    dispatch({
      type: OPTING_IN_GUEST_TO_CHAT_STARTED,
      payload: { chatId }
    })

    subscribersApi.updateStatus
      .consentGiven({ chatId })
      .then(() => {
        dispatch({
          type: OPTING_IN_GUEST_TO_CHAT_SUCCESS,
          payload: { chatId }
        })
      })
      .catch(err => {
        console.warn({ err })
        dispatch({
          type: OPTING_IN_GUEST_TO_CHAT_FAILED,
          payload: err
        })
      })
  }
}

export const getResolvedSalesChats = postData => {
  return async dispatch => {
    dispatch({
      type: GET_RESOLVED_SALES_CHATS_STARTED
    })

    try {
      const intentTypesResponse = await dashboardApi.getChatIntentTypes()

      dispatch({
        type: GET_INTENT_TYPES_SUCCESS,
        payload: intentTypesResponse
      })

      const response = await dashboardApi.getResolvedChats(postData)
      dispatch({
        type: GET_RESOLVED_SALES_CHATS_SUCCESS,
        payload: response
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: GET_RESOLVED_SALES_CHATS_FAILED,
        payload: err
      })
    }
  }
}

export const updateResolvedChats = postData => {
  return async dispatch => {
    dispatch({
      type: GET_RESOLVED_SALES_CHATS_STARTED
    })

    try {
      const response = await dashboardApi.getResolvedChats(postData)
      dispatch({
        type: GET_RESOLVED_SALES_CHATS_SUCCESS,
        payload: response
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: GET_RESOLVED_SALES_CHATS_FAILED,
        payload: err
      })
    }
  }
}
